import axios, { AxiosInstance } from "axios";
import { Config } from "../config";

const handleResponseError = (error: {
  response: { status: number; data: never; headers: Record<string, unknown> };
  toJSON: () => { message: string; name: string; stack: string };
}) => {
  if (error.response) {
    if (error.response.status === 401) {
      window.localStorage.removeItem("CURRENT_USER_TOKEN");
      const redirect_uri = encodeURIComponent(
        window.location.protocol +
          "//" +
          window.location.host +
          "/auth-callback",
      );
      window.location.href = `${Config.KEYCLOAK_URL}&redirect_uri=${redirect_uri}`;
    }
  }

  return Promise.reject(error);
};

function setupAxios(axios: AxiosInstance) {
  axios.defaults.withCredentials = true;
  axios.interceptors.response.use(undefined, handleResponseError);
}

let axiosInstance: AxiosInstance | null = null;

/**
 * Получить сконфигурированный экземпляр axios'а.
 */
export const getPreparedAxiosInstance = (): AxiosInstance => {
  if (axiosInstance == null) {
    axiosInstance = axios;

    setupAxios(axiosInstance);
  }

  return axiosInstance;
};
